var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","size":"24","color":"primary"}}):_vm._e(),(!_vm.loading)?_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }